module.exports = __webpack_public_path__ + "static/media/khaleel_idris.bd00eb0b.png";